import { useBreakPoints } from 'core';
import { CopyLinkGroup } from 'core/Components';
import { DateTime } from 'luxon';
import { InfoListCard, Modal, ModalProps, Stack } from 'ui';

interface TicketShareModalContentProps {
  eventName?: string;
  dateTime?: string;
  ticketName?: string;
  ticketUrl: string;
}

const TicketShareModalContent = ({
  eventName,
  dateTime,
  ticketName: ticketType,
  ticketUrl,
}: TicketShareModalContentProps) => {
  const { isSmallScreen } = useBreakPoints();

  const date = dateTime ? DateTime.fromISO(dateTime).toFormat('ccc, LLL d, yyyy') : '';
  const time = dateTime ? DateTime.fromISO(dateTime).toLocaleString(DateTime.TIME_SIMPLE) : '';

  return (
    <Stack gap="lg">
      <InfoListCard color="blue" header={<InfoListCard.Header title={eventName} />}>
        <InfoListCard.Item label="Date:" detail={date} />
        <InfoListCard.Item label="Time:" detail={time} />
        <InfoListCard.Item label="Ticket:" detail={ticketType} />
      </InfoListCard>
      <CopyLinkGroup link={ticketUrl} direction={isSmallScreen ? 'column' : 'row'} />
    </Stack>
  );
};

interface TicketShareModalProps extends ModalProps, TicketShareModalContentProps {}

const TicketShareModal = ({
  opened,
  onClose,
  ...ticketShareModalContentProps
}: TicketShareModalProps) => {
  return (
    <Modal title="Share Ticket" opened={opened} onClose={onClose}>
      <TicketShareModalContent {...ticketShareModalContentProps} />
    </Modal>
  );
};

export { TicketShareModal };
